/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geo_Label_South_Eastern_AsiaInputs */

const bn_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দক্ষিণ-পূর্ব এশিয়া`)
};

const de_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Südostasien`)
};

const el_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Νοτιοανατολική Ασία`)
};

const en_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`South-Eastern Asia`)
};

const es_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asia sudoriental`)
};

const fr_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asie du Sud-Est`)
};

const hi_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दक्षिण-पूर्वी एशिया`)
};

const hu_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Délkelet-Ázsia`)
};

const id_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asia Tenggara`)
};

const it_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asia sud-orientale`)
};

const ja_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`東南アジア`)
};

const ko_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`동남아시아`)
};

const nl_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuidoost-Azië`)
};

const pl_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azja Południowo-Wschodnia`)
};

const pt_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudeste Asiático`)
};

const ru_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Юго-Восточная Азия`)
};

const sv_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sydöstra Asien`)
};

const tr_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güneydoğu Asya`)
};

const uk_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Південно-Східна Азія`)
};

const vi_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đông Nam Á`)
};

const zh_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`东南亚`)
};

const zh_hant_geo_label_south_eastern_asia = /** @type {(inputs: Geo_Label_South_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`東南亞`)
};

/**
* | output |
* | --- |
* | "South-Eastern Asia" |
*
* @param {Geo_Label_South_Eastern_AsiaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const geo_label_south_eastern_asia = /** @type {((inputs?: Geo_Label_South_Eastern_AsiaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geo_Label_South_Eastern_AsiaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_geo_label_south_eastern_asia(inputs)
	if (locale === "de") return de_geo_label_south_eastern_asia(inputs)
	if (locale === "el") return el_geo_label_south_eastern_asia(inputs)
	if (locale === "en") return en_geo_label_south_eastern_asia(inputs)
	if (locale === "es") return es_geo_label_south_eastern_asia(inputs)
	if (locale === "fr") return fr_geo_label_south_eastern_asia(inputs)
	if (locale === "hi") return hi_geo_label_south_eastern_asia(inputs)
	if (locale === "hu") return hu_geo_label_south_eastern_asia(inputs)
	if (locale === "id") return id_geo_label_south_eastern_asia(inputs)
	if (locale === "it") return it_geo_label_south_eastern_asia(inputs)
	if (locale === "ja") return ja_geo_label_south_eastern_asia(inputs)
	if (locale === "ko") return ko_geo_label_south_eastern_asia(inputs)
	if (locale === "nl") return nl_geo_label_south_eastern_asia(inputs)
	if (locale === "pl") return pl_geo_label_south_eastern_asia(inputs)
	if (locale === "pt") return pt_geo_label_south_eastern_asia(inputs)
	if (locale === "ru") return ru_geo_label_south_eastern_asia(inputs)
	if (locale === "sv") return sv_geo_label_south_eastern_asia(inputs)
	if (locale === "tr") return tr_geo_label_south_eastern_asia(inputs)
	if (locale === "uk") return uk_geo_label_south_eastern_asia(inputs)
	if (locale === "vi") return vi_geo_label_south_eastern_asia(inputs)
	if (locale === "zh") return zh_geo_label_south_eastern_asia(inputs)
	return zh_hant_geo_label_south_eastern_asia(inputs)
});